import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';


import JobApprovalInbox from './containers/JobApprovalInbox';
import JobApprovalReview from './containers/JobApprovalReview';
import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';

import { initPage } from './actions';


const propTypes = exact({
  // eslint-disable-next-line react/no-unused-prop-types
  initPageAction: PropTypes.func.isRequired,
});


const TicketApprovalsPage = (props) => {
  return (
    <PageLayout
      title="Job Approvals"
      render={() => {
        return (
          <SplitLayout
            leftSize={3}
            leftRender={() => { return <JobApprovalInbox />; }}
            rightSize={9}
            rightRender={() => { return <JobApprovalReview />; }}
          />
        );
      }}
    />
  );
};


TicketApprovalsPage.propTypes = propTypes;


const mapDispatchToProps = {
  initPageAction: initPage,
};


const withRedux = connect(null, mapDispatchToProps);


const withInitPage = lifecycle({
  componentWillMount() {
    this.props.initPageAction();
  },
});


const enhance = compose(
  withRedux,
  withInitPage,
);


export default enhance(TicketApprovalsPage);
